// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/unit-conversions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/unit-conversions/unit-conversions.js';

mount([g0]);
